import { getTemplates } from '@/services/api';
import { useAuth } from '@/services/auth';
import { VisibilityFilter } from '@d-id/types';
import { AxiosHeaders } from 'axios';
import { useQuery } from 'react-query';

export const GET_TEMPLATES_KEY = 'get-templates';

export const useTemplates = ({ visibility = VisibilityFilter.VISIBLE }: { visibility?: VisibilityFilter } = {}) => {
    const { isAuthenticated } = useAuth();
    let headers = new AxiosHeaders();

    // This is hack in order to get the templates for guest users. (SoftAuthorizer requires authorization header)
    if (!isAuthenticated) {
        headers.setAuthorization('Bearer');
    }

    return useQuery([GET_TEMPLATES_KEY, visibility], () => getTemplates(headers, visibility), {
        refetchOnWindowFocus: false,
    });
};
